module.exports = __webpack_public_path__ + "static/img/icon-PTH.e56b430.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-PTH.svg
// module id = 8SAe
// module chunks = 0